import axios from "axios"
import { buildTimeoutError, isAxiosTimeoutError } from "../types/error"

const blogApiClient = axios.create({
  baseURL: `${process.env.REACT_APP_AUTH_API_URL}`,
  timeout: 300000, // 5 dakika
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
})

blogApiClient.interceptors.response.use(
  (response: any): any => {
    return response
  },
  (error) => {
    if (isAxiosTimeoutError(error)) {
      return Promise.reject(
        buildTimeoutError("Blog oluşturma işlemi zaman aşımına uğradı. Lütfen tekrar deneyin."),
      )
    }
    if (error.response?.status === 401 && error.response.data.message === "TOKEN_EXPIRED") {
      localStorage.removeItem("token")
      window.location.href = "/auth/login"
    }
    return Promise.reject(error)
  },
)

export interface BlogContent {
  title: string
  slug: string
  excerpt: string
  body: {
    _key: string
    _type: string
    children: {
      _key: string
      _type: string
      marks: string[]
      text: string
    }[]
    markDefs: {
      _key: string
      _type: string
      href: string
    }[]
    style: string
  }[]
  imagePrompt: ImagePrompt
}

export interface ImageContent {
  imageUrl: string
  altText: string
  prompt: ImagePrompt
}

export interface ImagePrompt {
  "Core Theme": string
  "Primary Subject": string
  "Setting & Environment": string
  Activity: string
  "Lighting & Atmosphere": string
  "Camera Specs & Visual Quality": string
  "Final Prompt Structure": string
}

export interface BlogGenerateResponse {
  blogs: BlogContent[]
  images: ImageContent[]
}

export interface BlogGenerationRequest {
  title: string
  topic: string
}

export interface BlogPublishRequest {
  selectedBlog: BlogContent
  selectedImage: ImageContent
}

class BlogGeneratorService {
  async generateBlogContent(title: string, topic: string): Promise<BlogGenerateResponse> {
    try {
      const response = await blogApiClient.post("/admin/blog/generate", {
        title,
        topic,
      })

      return response.data.data
    } catch (error: unknown) {
      if (isAxiosTimeoutError(error)) {
        throw buildTimeoutError(
          "Blog oluşturma işlemi zaman aşımına uğradı. Lütfen tekrar deneyin.",
        )
      }
      throw new Error("Blog oluşturulurken bir hata oluştu")
    }
  }

  async publishBlogToSanity(
    selectedBlog: BlogContent,
    selectedImage: ImageContent,
  ): Promise<{ slug: string }> {
    try {
      const response = await blogApiClient.post("/admin/blog/publish", {
        selectedBlog,
        selectedImage,
      })

      return response.data.data
    } catch (error: unknown) {
      if (isAxiosTimeoutError(error)) {
        throw buildTimeoutError(
          "Blog yayınlama işlemi zaman aşımına uğradı. Lütfen tekrar deneyin.",
        )
      }
      throw new Error("Blog yayınlanırken bir hata oluştu")
    }
  }
}

export const blogGeneratorService = new BlogGeneratorService()
